import { resolveMediaUrl } from "../../../utils/mediaUrl";

export default function MediaPreview({ item }) {
  if (!item?.url) return null;
  const src = resolveMediaUrl(item.url);
  const type = (item.mediaType || item.type || "").toLowerCase();

  if (type === "video") {
    return (
      <video
        src={src}
        controls
        className="h-32 w-full rounded-xl border border-gray-200 object-cover"
      />
    );
  }

  if (type === "pdf" || type === "document") {
    return (
      <a
        href={src}
        target="_blank"
        rel="noreferrer"
        className="flex h-32 items-center justify-center rounded-xl border border-gray-200 bg-slate-50 text-sm text-slate-600"
      >
        {item.altText || "Document"}
      </a>
    );
  }

  return (
    <img
      src={src}
      alt={item.altText || ""}
      className="h-32 w-full rounded-xl border border-gray-200 object-cover"
    />
  );
}
